import { render, staticRenderFns } from "./UploadWallpaperStepTwo.vue?vue&type=template&id=7b963aa4&"
import script from "./UploadWallpaperStepTwo.vue?vue&type=script&lang=js&"
export * from "./UploadWallpaperStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports